<template>
  <div class="realize_wrap">
    <div class="realize_img">
      <div class="img_tit">
        <i :class="calcClass">{{$t("about.bannerTitle")}}</i>
        <div class="img_desc">{{$t("about.bannerSubtitle")}}</div>
      </div>
    </div>
    <div class="realize_nav_wrap">
      <div class="breadcrumb">
        <img class="home-icon" src="@/assets/img/home/home.png" alt=""/>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="home" :to="{ path: '/' }">
            {{$t("contactUs.title")}}
          </el-breadcrumb-item>
          <el-breadcrumb-item> {{$t("nav.about")}} </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <!--关于晴天-->
    <div class="brain_title">
      {{$t("about.title")}}
      <div class="sub_title">{{$t("homeAbout.subTitle")}}</div>
    </div>
    <div class="brain_desc">
      <div class="explain_bg" v-animate-on-scroll="'animate__backInRight'" style="float: right">
        <img class="explain_img" src="@/assets/img/home/1749007657_bzMz.jpg" alt=""/>
        <div class="explain_title">
          HCC<br/>
          GROUP<br/>
          LIMITED
        </div>
      </div>
      <div class="explain" v-animate-on-scroll="'animate__backInLeft'">
        {{$t("homeAbout.brainDesc1")}}<br/>
        {{$t("homeAbout.brainDesc2")}}
      </div>
    </div>
    <!--创始人-->
    <div class="founder">
      <div class="founder_title">{{$t("about.founderTitle")}}</div>
      <div class="founder_en">{{$t("about.founderSubtitle")}}</div>
      <div class="founder_profile">
        <div class="describes">
          <div class='segment'></div>
          <span class="name">{{$t("homeAbout.founderName")}}</span>
          <span class="degree">{{$t("homeAbout.founderEn")}}</span>
        </div>
        <div class="introduced">
          <div class="describe" v-animate-on-scroll="'animate__fadeInUp'">
            <div class="avatar">
              <img class="avatar_img" src="@/assets/img/home/founder.png" alt=""/>
            </div>
            <span>{{$t("homeAbout.founderDescribe1")}}</span><br/>
            <br/><br/><span>{{$t("homeAbout.founderDescribe2")}}</span>
          </div>
        </div>
      </div>
    </div>
    <!--主席寄语-->
    <div class="message">
      <div class="message_title">{{$t("about.messageTitle")}}</div>
      <div class="message_sub">{{$t("about.messageSubtitle")}}</div>
      <div class="descriptive-bg" v-animate-on-scroll="'animate__zoomIn'">
        <div class="space"></div>
        <div class="descriptive">
          <p>{{$t("about.messageDescriptive1")}}</p>
          <br/>
          <p>{{$t("about.messageDescriptive2")}}</p>
          <br/>
          <p>{{$t("about.messageDescriptive3")}}</p>
          <br/>
          <p>{{$t("about.messageDescriptive4")}}</p>
          <br/>
          <p>{{$t("about.messageDescriptive5")}}</p>
        </div>
      </div>

    </div>
    <!--标志解读-->
    <div class="interpret">
      <div class="interpret_title">{{$t("about.interpretTitle")}}</div>
      <div class="interpret_sub">{{$t("about.interpretSubtitle")}}</div>
      <div class="reading">
        <div class="reading-top">
          <div class="block block-left" v-animate-on-scroll="'animate__zoomIn'">
            <strong>{{$t("about.interpretTitle1")}}</strong>
            <p>{{$t("about.interpretSubtitle1")}}</p>
          </div>
          <div class="reading-icon">
            <img src="@/assets/img/other/reading-icon.png" alt=""/>
          </div>
          <div class="block block-right" v-animate-on-scroll="'animate__zoomIn'">
            <strong>{{$t("about.interpretTitle2")}}</strong>
            <p class="colour">{{$t("about.interpretSubtitle2")}}</p>
          </div>
        </div>
        <div class="reading-bottom">
          <div class="block" v-animate-on-scroll="'animate__zoomIn'">
            <strong>{{$t("about.interpretTitle3")}}</strong>
            <p class="concept">
              {{$t("about.interpretSubtitle3")}}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!--核心价值观-->
    <div class="core-values">
      <div class="core-values-title"> {{$t("about.coreValuesTitle")}} </div>
      <div class="core-values-sub">{{$t("about.coreValuesSubTitle")}} </div>
      <div class="list" v-animate-on-scroll="'animate__zoomIn'">
        <div class="list-item" v-for="(item,index) in list" :key="index">
          <div class="content-main">
            <img class="icon" :src="item.img" alt=""/>
            <div class="list-bottom">
              <div class="label">{{item.label}}</div>
              <div class="content">{{item.content}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CallMe />
  </div>
</template>

<script>
/* eslint-disable */
import CallMe from '@/components/callme/index'
export default {
  computed: {
    list()
    {
      return [
        {
          label:this.$t("about.coreValuesLabel1"),
          content:this.$t("about.coreValuesContent1"),
          img:require("../../assets/img/other/icon-1.png")
        },
        {
          label: this.$t("about.coreValuesLabel2"),
          content:this.$t("about.coreValuesContent2"),
          img:require("../../assets/img/other/icon-2.png")
        },
        {
          label:this.$t("about.coreValuesLabel3"),
          content:this.$t("about.coreValuesContent3"),
          img:require("../../assets/img/other/icon-4.png")
        },
        {
          label:this.$t("about.coreValuesLabel4"),
          content:this.$t("about.coreValuesContent4"),
          img:require("../../assets/img/other/icon-3.png")
        }
      ]
    },
    calcClass()
    {
      return (this.$i18n.locale === 'en' || this.$i18n.locale === 'ar') ? 'english-layout' : '';
    }
  },
  data() {
    return {
    }
  },
  methods: {
  },
  components: {
    CallMe
  },
  created(){
    this.tabSelectIndex = this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
  },
  mounted() {
  },
  watch: {
    $route() {
      this.tabSelectIndex = this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
    },
  },
}
</script>

<style lang="scss" scoped>
//@import "@/assets/css/common.scss";
.realize_wrap {
  position: relative;
  font-family: $font-family;
  background-color: #ffffff;
  .realize_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background-image: url('../../assets/img/home/about-us.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    .img_tit {
      width: 70%;
      font-weight: bold;
      margin: 0 auto;
      transition: all 0.5s ease 0s;
      i{
        font-size: $banner-font-size;
        border-bottom: 4px #fff solid;
        padding-bottom: 10px;
        @media screen and (max-width: 768px) {
          font-size: $phone-banner-font-size;
        }
      }
    }
    .img_desc {
      font-size: $banner-sub-font-size;
      margin-top: 15px;
      text-transform:uppercase;
      @media screen and (max-width: 768px) {
        font-size: $phone-banner-sub-font-size;
      }
      outline:none;
    }
    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;
      &:hover {
        color: #fff;
        background: orange;
      }
      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }
  .realize_nav_wrap {
    background-color: #eeeeee;
    //width: 70%;
    margin: 0 auto;
    @media screen and (max-width: 768px) {
      height: 50px;
    }
    .realize_nav {
      //height: 100%;
      display: flex;
      align-items: center;
      .active {
        font-weight: bold;
        color: #000;
      }
      .realize_item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .nav_top {
          font-size: 18px;
          @media screen and (max-width: 768px) {
            font-size: 14px;
          }
        }
        .nav_bottom {
          width: 30%;
          height: 4px;
          margin-top: 10px;
          background: #2091d3;
        }
      }
    }
  }
  .breadcrumb{
    width: $about-width;
    margin: 0 auto;
    padding: 20px 0px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .home-icon{
      height: 20px;
      width: 20px;
      margin-right: 15px;
    }
  }
  .way{
    width: 100%;
    margin-top: 20px;
    margin-bottom: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .contact-item {
      margin: 0 10px;
      flex: 1;
      padding: 20px;
      box-sizing: border-box;
      background-color: #f2f2f2;
    }
    .icon {
      width: 50px;
      height: 50px;
      margin-right: 10px;
    }
    .phone-icon {
      background: url('../../assets/img/website/1.png') no-repeat center center;
      background-size: contain;
      margin-bottom: 20px;
    }
    .email-icon {
      background: url('../../assets/img/website/2.png') no-repeat center center;
      background-size: contain;
      margin-bottom: 20px;
    }
    .time-icon {
      background: url('../../assets/img/website/3.png') no-repeat center center;
      background-size: contain;
      margin-bottom: 20px;
    }
    .text {
      display: flex;
      flex-direction: column;
    }
    .title {
      font-weight: bolder;
      font-size: 18px;
      color: #000;
      margin-bottom: 5px;
    }
    .content {
      margin: 0;
      font-size: 18px;
      color: #666;
    }
  }
  @media screen and (max-width: 768px) {
    .breadcrumb{
      padding: 20px 0;
      box-sizing: border-box;
      background-color: #f6f7f9;
      display: none;
    }
    .realize_nav_wrap {
      width: 100%;
      height: auto;
      margin-top: 10px;
    }
    .way{
      width: 90%;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin-top: 20px;
      .contact-item {
        width: 100%;
        margin-bottom: 20px;
        padding: 20px;
        box-sizing: border-box;
        background-color: #f2f2f2;
        font-size: 18px;
        .icon {
          width: 50px;
          height: 50px;
          margin-right: 10px;
        }
        .title {
          font-weight: bolder;
          font-size: 18px;
          color: #000;
          margin-bottom: 5px;
        }
        .content {
          margin: 0;
          font-size: 18px;
          color: #666;
        }
      }
    }
  }
  .brain_title {
    position: relative;
    color: #203040;
    font-size: $title-font-size;
    font-weight: bold;
    padding: 60px 0 80px 0;
    text-align: center;
    @media screen and (max-width: 768px) {
      padding: 1rem 0 2rem 0;
      font-size: $phone-title-font-size;
    }
  }
  .sub_title{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    color: #fccc0c;
    font-size: $subtitle-font-size;
    @media screen and (max-width: 768px) {
      font-size: $phone-subtitle-font-size;
      left:50%;
      transform: translateX(-50%);
    }
  }
  .brain_desc {
    width: $about-width;
    margin: 0 auto;
    position: relative;
    color: rgba(32, 48, 64, 0.75);
    font-size: $content-font-size;
    padding-bottom: 50px;
    @media screen and (max-width: 768px) {
      width: 95%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 0;
    }
  }
  .explain{
    width: 100%;
    font-size: 1rem;
    line-height: 2;
    color: #000000;
    text-align: left;
    margin-right: 10px;
    margin-top: 0.8rem;
    @media screen and (max-width: 768px) {
      font-size: 0.9rem;
      width: 95%;
    }
  }
  .explain_bg{
    position: relative;
    display: flex;
    align-items: center;
    //justify-content: center;
    width: 60%;
    height: auto;
    background: #fccc0c;
    margin-left: 30px;
    @media screen and (max-width: 768px) {
      width: 95%;
      height: 95%;
      margin: 1.2rem 0;
    }
  }
  .explain_img{
    height: 95%;
    width: 95%;
    padding-right: 15%;
    @media screen and (max-width: 768px) {
      //margin: 20px;
      width: 86%;
      height: 100%;
      padding-right: 10%;
    }
  }
  .explain_title{
    position: absolute;
    right: -20px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 85%;
    width: 25%;
    color: #ffffff;
    font-size: 23px;
    @media screen and (max-width: 768px) {
      width: 25%;
      height: 100%;
      font-size: 0.8rem;
    }
  }
  //创始人
  .founder{
    position: relative;
    margin: 70px 5% 0 15%;
    padding-bottom: 20px;
    background: #f9f9f9;
    @media screen and (max-width: 768px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      background:none;
      height: 100%;
      margin: 1.5rem 5% 0 5%;
    }
    .founder_title{
      position: relative;
      color: #203040;
      font-size: $title-font-size;
      font-weight: bold;
      padding: 30px 0 0 0;
      text-align: center;
      @media screen and (max-width: 768px) {
        font-size: $phone-title-font-size;
      }
    }
    .founder_en{
      color: #fccc0c;
      font-size: $subtitle-font-size;
      text-align: center;
      @media screen and (max-width: 768px) {
        font-size: $phone-subtitle-font-size;
      }
    }
    .founder_profile{
      @media screen and (max-width: 768px) {
        position: relative;
        display: flex;
        flex-direction: column;
        margin-top: 2.5rem;
      }
      .describes{
        position: absolute;
        top: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 20px 30px 20px 30px;
        color: #ffffff;
        /*width: 12rem;*/
        background: #F9CA0D;
        @media screen and (max-width: 768px) {
          position: relative;
          align-items: center;
          width: 100%;
          height: 5rem;
          margin-bottom:2rem;
        }
        .segment{
          position: absolute;
          left: 30px;
          height: 50%;
          width: 8px;
          background-color: #ffffff;
          @media screen and (max-width: 768px) {
            display: none;
          }
        }
        .name{
          font-size: 1.9rem;
          margin-left: 18px;
          @media screen and (max-width: 768px) {
            font-size: 1.5rem;
          }
        }
        .degree{
          font-size: 1.2rem;
          margin-left: 20px;
          @media screen and (max-width: 768px) {
            font-size: 0.8rem;
          }
        }
      }
      .introduced{
        position: relative;
        margin:50px 15% 0 15%;
        @media screen and (max-width: 768px) {
          display: flex;
          margin-left:0;
          width: 100%;
          margin-top: 1rem;
        }
        .describe{
          padding-top: 10px;
          padding-bottom:90px;
          @media screen and (max-width: 768px) {
            padding:0;
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          span{
            font-weight: 500;
            font-size: $content-font-size;
            line-height: 1.7;
            color: #000000;
            @media screen and (max-width: 768px) {
              font-size: $phone-content-font-size;
            }
          }
        }
        .avatar{
          float:left;
          height: 394.8px;
          width: 250px;
          margin-right: 20px;
          @media screen and (max-width: 768px) {
            width: 20rem;
            height:30rem;
            display: flex;
            justify-content: center;
            margin:0 0 1rem 0;
          }
          .avatar_img{
            height: 100%;
            width: 100%;
          }
        }
      }

    }
  }
  //主席寄语
  .message{
    .message_title{
      position: relative;
      color: #203040;
      font-size: $title-font-size;
      font-weight: bold;
      padding-top: 60px;
      text-align: center;
      @media screen and (max-width: 768px) {
        padding: 1rem 0 0 0;
        font-size: $phone-title-font-size;
      }
    }
    .message_sub{
      color: #fccc0c;
      font-size: $subtitle-font-size;
      text-align: center;
      padding-bottom: 30px;
      @media screen and (max-width: 768px) {
        font-size: $phone-subtitle-font-size;
        padding-bottom: 1rem;
      }
    }
  }
  //主席寄语
  .descriptive-bg{
    display: flex;
    justify-content: space-between;
    margin:0px 15% 0px 15%;
    @media screen and (max-width: 768px) {
      margin:0px 5% 0px 5%;
    }
    .space{
      width:10%;
      //height: 100%;
      background-color:#F9CA0D;
      @media screen and (max-width: 768px) {
        width:0;
        background:none;
      }
    }
    .descriptive{
      color: #ffffff;
      margin-left: 2%;
      height: 100%;
      width: 88%;
      background:url("../../assets/img/other/msg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      font-weight: 500;
      font-size: $content-font-size;
      padding: 30px 80px;
      @media screen and (max-width: 768px) {
        font-size: $phone-content-font-size;
        background:none;
        color: #333333;
        width:100%;
        padding:0
      }
    }
  }
  //标志解读
  .interpret{
    position: relative;
    .interpret_title{
      position: relative;
      color: #203040;
      font-size: $title-font-size;
      font-weight: bold;
      padding-top: 60px;
      text-align: center;
      @media screen and (max-width: 768px) {
        padding: 1rem 0 0 0;
        font-size: $phone-title-font-size;
      }
    }
    .interpret_sub{
      color: #fccc0c;
      font-size: $subtitle-font-size;
      text-align: center;
      padding-bottom: 30px;
      @media screen and (max-width: 768px) {
        font-size: $phone-subtitle-font-size;
        padding-bottom: 1rem;
      }
    }
    .reading{
      margin:0 10%;
      @media screen and (max-width: 768px) {
        margin:0;
      }
      .reading-top{
        position: relative;
        display: flex;
        justify-content: center;
        @media screen and (max-width: 768px) {
          flex-direction: column;
        }
      }
      .block-left{
        width: 30%;
        @media screen and (max-width: 768px) {
          width: 90%;
          margin: 12rem 5% 0 5%;
        }
      }
      .block-right{
        width: 30%;
        @media screen and (max-width: 768px) {
          //width: 100%;
          width: 90%;
          padding: 1rem 0 0 0;
          margin: 0 5%;
        }
      }
      .block{
        display: flex;
        flex-direction: column;
        align-items: center;
        strong{
          font-size: 1.4rem;
          margin-bottom: 15px;
          @media screen and (max-width: 768px) {
            font-size: 1.1rem;
          }
        }
        p{
          font-size: $content-font-size;
          line-height: 32px;
          @media screen and (max-width: 768px) {
            font-size: $phone-content-font-size;
            line-height: 1.5rem;
          }
        }
        .colour{
          width: 100%;
          margin-left: 40px;
          @media screen and (max-width: 768px) {
            margin: 0
          }
        }
      }
      .reading-bottom{
        margin: 30px 8.5% 0 8.5%;
        @media screen and (max-width: 768px) {
          margin: 0 5%;
        }
      }

      .reading-icon{
        height: 200px;
        width: 200px;
        margin:0 5% 0 5%;
        @media screen and (max-width: 768px) {
          position: absolute;
          top: 0;
          left: 40%;
          transform: translateX(-40%);
          height:10rem;
          width: 10rem;
        }
        img{
          height: 100%;
          width: 100%;
        }
      }
    }
  }
  //核心价值观
  .core-values{
    .core-values-title{
      position: relative;
      color: #203040;
      font-size: $title-font-size;
      font-weight: bold;
      padding-top: 60px;
      text-align: center;
      @media screen and (max-width: 768px) {
        padding: 1rem 0 0rem 0;
        font-size: $phone-title-font-size;
      }
    }
    .core-values-sub{
      color: #fccc0c;
      font-size: $subtitle-font-size;
      text-align: center;
      padding-bottom: 30px;
      @media screen and (max-width: 768px) {
        font-size: $phone-subtitle-font-size;
        padding-bottom: 1rem;
      }
    }
    .list{
      margin: 0 16% 40px 16%;
      display: flex;
      justify-content: space-between;
      @media screen and (max-width: 768px) {
        margin: 0 4%;
        flex-wrap: wrap;
        justify-content: space-around;
      }
      .list-item{
        width: 24%;
        min-height: 500px;
        background: #FFFFFF;
        border-radius: 12px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        overflow: hidden;
        .content-main{
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          height: 100%;
        }
        @media screen and (max-width: 768px) {
          margin:0;
          width: 45%;
          min-height: 22rem;
          border-radius: 0.3rem;
          box-shadow: 0 0.2rem 0.5rem 0 rgba(0, 0, 0, 0.1);
          margin-bottom: 1.5rem;
        }
        .icon{
          height: 150px;
          width: 150px;
          margin: 40px 0 20px 0;
          @media screen and (max-width: 768px) {
            height: 6rem;
            width: 6rem;
            margin:2rem 0 1rem 0;
          }
        }
        .list-bottom{
          display: flex;
          flex-direction: column;
          align-items: center;
          @media screen and (max-width: 768px) {
            padding: 0 1rem;
          }
          .label{
            font-size: 1.6rem;
            font-weight: 600;
            @media screen and (max-width: 768px) {
              font-size: 1.2rem;
            }
          }
          .content{
            font-size: $content-font-size;
            padding:30px;
            line-height: 25px;
            color: #333333;
            @media screen and (max-width: 768px) {
              font-size: $phone-content-font-size;
              padding:0;
              padding-top: 1rem;
              line-height:1.4rem;
            }
          }
        }
        &:hover{
          .content-main{
            background-color: #794bb7;
            cursor: pointer;
            animation: flipInY .8s; /* 应用 bounce 动画 */
            animation-fill-mode: both; /* 保持动画结束状态 */
            color: #fff;
            .content{
              color: #fff;
            }
          }
        }
      }
    }
  }
}
</style>
